import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';

import { MysqlService } from './../../../../services/mysql.service';
import { SubjectAttendence } from './../../../../api/subjectAttenence';
import {DemoService} from '../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-user-profile-display',
  templateUrl: './user-profile-display.component.html',
  styleUrls: ['./user-profile-display.component.css']
})
export class UserProfileDisplayComponent implements OnInit {

  @Input() user_id: number;
  users_attended: any;

  constructor(    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef) { }

  ngOnInit() {
    this.getUsersById(this.user_id);
  }


/*
  getUsersById(user_id) {
    this._demoService.getUsersById(user_id).subscribe(
      data => { this.users_attended = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      // this.users_updated = data;
      },
      error => {
        console.error('Error Loading User!');
       return Observable.throw(error);
      }
    ); }

*/


// Changed to get the brand ID of the logged in user.
    getUsersById(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        data => { this.users_attended = data;
         // console.log("Done loadng USER");
         // console.log(this.users);
        // this.users_updated = data;
        },
        error => {
          console.error('Error Loading User!');
        return console.log(error);
        }
      ); }



   




}
